export const ADD_NC_ROOT = "ADD_NC_ROOT";
export const UNSHIFT_NC_ROOT = "UNSHIFT_NC_ROOT";
export const CLEAR_NC_ROOT = "CLEAR_NC_ROOT";
export const CLEAR_TYPE_NC_ROOT = "CLEAR_TYPE_NC_ROOT";
export const ADD_NC_CONTENT = "ADD_NC_CONTENT";
export const CLEAR_NC_CONTENT = "CLEAR_NC_CONTENT";
export const RESET_NC_STATE = "RESET_NC_STATE";
export const SET_NC_STATE_POSITION_BACK = "SET_NC_STATE_POSITION_BACK";
export const SET_NC_STATE_POSITION_NEXT = "SET_NC_STATE_POSITION_NEXT";
export const SET_NC_STATE_POSITION_PREVIOUS = "SET_NC_STATE_POSITION_PREVIOUS";
export const SET_NC_STATE_LEVEL_NEXT = "SET_NC_STATE_LEVEL_NEXT";
